// extracted by mini-css-extract-plugin
export default {"aliases_column":"styles_aliases_column__US62b"};